import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { exchangeCustomerSession } from '../services/customerAuthService';

const CustomerAuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    if (!sessionId) return navigate('/diy', { replace: true });
    exchangeCustomerSession(sessionId).then((result) => {
      window.history.replaceState(null, '', '/diy');
      if (result.ok) window.dispatchEvent(new Event('tweeporter-auth-changed'));
      navigate('/diy', { replace: true, state: { customer: result.ok ? result.data : null } });
    });
  }, [location.hash, navigate]);

  return <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6 text-center" data-testid="customer-auth-callback" aria-label="Completing sign in"><p className="text-sm font-medium text-slate-600">Completing your sign-in…</p></div>;
};

export default CustomerAuthCallback;